module.exports = __webpack_public_path__ + "img/1-2.4c4f8497.png";